import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TokenService } from 'src/app/core/services/token/token.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  public showLoader = false;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private tokenService: TokenService,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      clientId: ['', [Validators.required]],
      secret: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.tokenService.clearToken()
  }

  onLogin() {
    if (this.loginForm.valid) {
      const { clientId, secret } = this.loginForm.value;
      this.showLoader = true;
      this.http.post(environment.apiUrl + 'auth', { clientId, secret }).subscribe(
      (resp: any) => {
        const token = resp.token
        if (typeof token === 'string'){
          this.tokenService.setToken(token);
        }
        this.showLoader = false
        this.router.navigate(['/registro']);
      },
      (error) => {
        this.showLoader = false
        console.log('erro', error)
        Swal.fire({
          icon: 'error',
          title: 'Erro ao tentar logar',
          text: error.error.message
        })
      }
      )
    } else {
      console.log('Formulário inválido');
    }
  }

}
